import { memo } from 'react'
import EmptyProfileIcon from '../../../assets/icons/noAvatarIcon3.svg?react'
import styles from './UserAvatar.module.css'

interface UserAvatarProps {
  imageUrl?: string | null
  username?: string
  className?: string
  iconClassName?: string
  /** CSS класс для EmptyProfileIcon */
  emptyIconClassName?: string
}

/**
 * Компонент для отображения аватарки пользователя.
 * Автоматически определяет, нужно ли показать SVG placeholder или реальное изображение.
 * 
 * @param imageUrl - URL изображения или null/undefined если аватарки нет
 * @param className - CSS класс для wrapper элемента (размеры, border-radius)
 * @param iconClassName - CSS класс для SVG иконки внутри wrapper
 */
export const UserAvatar = memo(function UserAvatar({
  imageUrl,
  username = 'User',
  className = '',
  iconClassName = '',
  emptyIconClassName = ''
}: UserAvatarProps) {
  // Если аватарка есть, показываем изображение
  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={`${username} avatar`}
        className={className}
      />
    )
  }

  // Если нет аватарки и нужна EmptyProfileIcon (для других пользователей)
  return (
    <div className={`${styles.placeholderIconWrapper} ${emptyIconClassName}`}>
      <EmptyProfileIcon className={`${styles.placeholderIcon} ${iconClassName}`} aria-label={`${username} avatar`} />
    </div>
  )

})
